import * as React from 'react';
import { graphql } from 'react-apollo';

import { adminDashboardPageBaseQuery } from 'bundles/enterprise-admin/AdminDashboardPageQuery';
import type {
  AdminDashboardPageBaseQuery,
  AdminDashboardPageBaseQueryVariables,
} from 'bundles/enterprise-admin/__generated__/AdminDashboardPageBaseQuery';
import type { ThirdPartyOrganization } from 'bundles/enterprise-admin/types';
import filterExistsOrDefault from 'bundles/enterprise-legacy-learner-home/utils/filterExistsOrDefault';

// ThirdPartyOrganization will always be defined due to the branch function in AdminDashboard.
export const ThirdPartyOrganizationContext = React.createContext<ThirdPartyOrganization>({} as $TSFixMe);

type PropsFromCaller = {
  thirdPartySlug: string;
  children: React.ReactNode;
};

type PropsFromGraphql = {
  thirdPartyOrganization: ThirdPartyOrganization;
};

export const ThirdPartyOrganizationProviderBase = ({
  thirdPartyOrganization,
  children,
}: React.PropsWithChildren<PropsFromGraphql>) => {
  return (
    <ThirdPartyOrganizationContext.Provider value={thirdPartyOrganization}>
      {children}
    </ThirdPartyOrganizationContext.Provider>
  );
};

export const useThirdPartyOrganization = () => React.useContext(ThirdPartyOrganizationContext);

export default graphql<
  PropsFromCaller,
  AdminDashboardPageBaseQuery,
  AdminDashboardPageBaseQueryVariables,
  PropsFromGraphql
>(adminDashboardPageBaseQuery, {
  skip: ({ thirdPartySlug }) => !thirdPartySlug,
  options: ({ thirdPartySlug }) => ({
    variables: {
      thirdPartySlug,
    },
  }),
  // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  props: ({ data }) => {
    return {
      thirdPartyOrganization: filterExistsOrDefault(data?.ThirdPartyOrganizationsV1Resource?.bySlug?.elements, [])[0],
    };
  },
})(ThirdPartyOrganizationProviderBase);
